export default __webpack_public_path__ + "static/media/photo--sm--20.2de0b968.jpg";